// close search
var searchClose = document.querySelector('.search__close');
var search = document.querySelector('body .search');

if (searchClose && search) {
  searchClose.addEventListener('click', function() {
    search.classList.remove('search--active');
  });
}
